import { QueryParams } from '@/model';
import apiClient from '../api/apiClient';
import { buildApiUrl } from '../utils';

import {
  GetChallengeByUUIDResponse,
  GetChallengeMetricsResponse,
  GetChallengesResponse,
  PostChallengeResponse,
  PutChallengeResponse,
} from '../response/challenge';

export class ChallengeService {
  static getChallenge(params?: QueryParams) {
    return apiClient.get<GetChallengesResponse>(buildApiUrl('/api/v1/interactive-area/challenge'), params);
  }

  static getChallengeByUUID(id: string) {
    const url = buildApiUrl('/api/v1/interactive-area/challenge/:id', { id });
    return apiClient.get<GetChallengeByUUIDResponse>(url, undefined);
  }

  static getChallengeMetrics() {
    const url = buildApiUrl('/api/v1/interactive-area/challenge/metrics');
    return apiClient.get<GetChallengeMetricsResponse>(url, undefined);
  }

  static postChallenge(data: any) {
    return apiClient.createWithFile<PostChallengeResponse>(buildApiUrl('/api/v1/interactive-area/challenge'), data);
  }

  static putChallenge(id: string, data: any) {
    const url = buildApiUrl('/api/v1/interactive-area/challenge/:id', { id });
    return apiClient.updateWithFile<PutChallengeResponse>(url, data);
  }

  static deleteChallenge(id: string) {
    const url = buildApiUrl('/api/v1/interactive-area/challenge/:id', { id });
    return apiClient.delete<void>(url);
  }

  static putChallengeClose(id: string) {
    const url = buildApiUrl('/api/v1/interactive-area/challenge/:id/close', { id });
    return apiClient.update<void>(url);
  }

  static putChallengePublished(id: string) {
    const url = buildApiUrl('/api/v1/interactive-area/challenge/:id/publish', { id });
    return apiClient.update<void>(url);
  }

  static putChallengeUnpublished(id: string) {
    const url = buildApiUrl('/api/v1/interactive-area/challenge/:id/unpublish', { id });
    return apiClient.update<void>(url);
  }
}
